<template>
<div id="login">
  <img class="mx-auto" id="logo" :src="logoURL">
    <PasswordReset v-if="showPasswordReset" @close="togglePasswordReset()"></PasswordReset>
<div  v-if="!showPasswordReset">
    <v-card-title>
        <h1 class="display-1 mx-auto">Connecte toi</h1>
    </v-card-title>
    <v-card-text>
        <v-form>

            <form v-if="showLoginForm" @submit.prevent>
                <v-text-field label="email" prepend-icon="mdi-email" v-model.trim="loginForm.email" id="email1" />
                <v-text-field @click:append="ShowPassword = !ShowPassword" label="password" prepend-icon="mdi-lock" :append-icon="ShowPassword ? 'mdi-eye':'mdi-eye-off'" v-model.trim="loginForm.password" :type="ShowPassword ? 'text':'password'" id="password1" />
                <v-divider></v-divider>
                <v-card-actions>
                <v-flex>
                    <v-btn color="#EC8953"  @click="login()" class="button">c'est parti</v-btn>
                    <v-spacer></v-spacer>
                </v-flex>
                </v-card-actions>
<br>
                <v-card-actions>
                  <v-flex>
                    <v-btn color="#FEF3C8" @click="togglePasswordReset()">Mot de passe oublié ?</v-btn>
                  </v-flex>
                </v-card-actions>
                <v-divider></v-divider>
                <br>
                <a @click="toggleForm()">Créer un compte &rarr; </a>

            </form>

            <form v-else @submit.prevent>

                <v-text-field label="Nom" prepend-icon="mdi-account-circle" v-model.trim="signupForm.name" type="text"  id="name" />

                <v-text-field label="Email" prepend-icon="mdi-email" v-model.trim="signupForm.email" type="text" id="email2" />

                <v-text-field label="Mot de passe" prepend-icon="mdi-lock" v-model.trim="signupForm.password" type="password"  id="password2" />

                <v-btn color="#EC8953" @click="signup()">C'est parti !</v-btn>
                <br>
                <br>
                <br>
                <v-btn color="info" @click="toggleForm()"><v-icon>mdi-keyboard-backspace</v-icon> Retour au login</v-btn>

            </form>
        </v-form>
    </v-card-text>
</div>

<v-snackbar
      absolute
      centered
      :value.sync="snackbar"
      color="deep-purple accent-4"
      elevation="24"
    >
      {{ errorMsg }}
    </v-snackbar>

</div>
</template>

<script>
import PasswordReset from '@/views/PasswordReset'
import { mapState } from 'vuex'
export default {
  components: {
    PasswordReset
  },
  data () {
    return {
      ShowPassword: false,
      logoURL: require('../assets/logo.png'),
      loginForm: {
        email: '',
        password: ''
      },
      signupForm: {
        name: '',
        title: '',
        email: '',
        password: ''
      },
      showLoginForm: true,
      showPasswordReset: false
    }
  },
  methods: {
    toggleForm () {
      this.showLoginForm = !this.showLoginForm
    },
    togglePasswordReset () {
      this.showPasswordReset = !this.showPasswordReset
    },
    login () {
      this.$store.dispatch('login', {
        email: this.loginForm.email,
        password: this.loginForm.password
      })
    },
    signup () {
      this.$store.dispatch('signup', {
        email: this.signupForm.email,
        password: this.signupForm.password,
        name: this.signupForm.name,
        title: this.signupForm.title
      })
    }
  },
  computed: {
    ...mapState([
      'errorMsg', 'snackbar'
    ])

  }
}
</script>

<style scoped>

#login {
  background-color: #bdddbf;
}

#logo {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue